var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInboxAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.256 15.419v3.279c0 .578.468 1.046 1.046 1.046h13.396c.578 0 1.046-.468 1.046-1.046v-3.28h-4.348c-.155 2.044-1.14 2.791-3.396 2.791-2.208 0-3.227-.807-3.394-2.79h-4.35zM13.226 3c.142 0 .282.013.419.038a.628.628 0 0 1 .768.291c.12.073.236.157.343.253l3.61 3.209c.149.131.278.28.386.443a.629.629 0 0 1 .34.818c.032.15.047.304.047.46v2.41l1.795 3.588a.624.624 0 0 1 .065.242v3.946a2.302 2.302 0 0 1-2.3 2.302H5.302A2.302 2.302 0 0 1 3 18.698V14.79c0-.099.023-.192.063-.275l.003-.006 1.794-3.59V5.302A2.302 2.302 0 0 1 7.164 3h6.064zm0 1.256H7.164c-.578 0-1.047.468-1.047 1.046v8.86H9.21c.347 0 .628.282.628.629 0 1.744.425 2.162 2.163 2.162 1.795 0 2.163-.35 2.163-2.162 0-.347.28-.628.628-.628l3.092-.001v-5.65l-.004-.071h-4.02a.628.628 0 0 1-.627-.627V4.256h-.006zm5.913 9.474v.432h.216l-.216-.432zM4.86 13.728l-.217.434h.217v-.434zm12.061-6.542-2.433-2.162v2.162h2.433z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-10h268v44H-24z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInboxAll);
export default __webpack_public_path__ + "static/media/ic-inbox-all.ddb6ba163a14f6f90f28dde6119dabac.svg";
export { ForwardRef as ReactComponent };